import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import ResumeTable from "../Components/Resumes/ResumeTable";
import ResumeDialogBox from "../Components/Resumes/ResumeDialogBox";
import axiosInstance from "../utilities/Axios";
import { useTheme } from "../Hooks/ThemeContext/ThemeContext";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Button, Card, Divider, IconButton } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import Scaffold from "..//Components/Layout/Scaffold";
import useQuery from "../Hooks/useQueryHook/useQueryHook";

const default_templates = [
  {
    order: "1",
    title: "visa",
  },
];

const Recruitments = () => {
  const query = useQuery();
  const limit = 10;
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  let [hide, setHide] = useState(true);
  const [jobTitleList, setJobTitleList] = useState<any[]>([]);
  let [filter, setfilter] = useState<any>({ rec_status: true, no_passport: false });
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");
  const theme = useTheme();
  const [triggerResumeId, setTriggerResumeId] = useState<string | null>(null);
  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  useEffect(() => {
    const resumeId = query.get("resume_id");
    if (resumeId) {
      setTriggerResumeId(resumeId);
    }
  }, []);

  // useEffect(() => {
  //   getJobTitleList();
  // }, []);
  function hideDiv() {
    if (hide == true) {
      setHide(false);
    } else {
      setHide(true);
    }
  }

  function changeFilters(key: string, value: string) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }
  const getJobTitleList = async () => {
    setIsLoading(true)
    try {
      const response = await axiosInstance.get(
        `/v1/job-titles?type=${theme.theme}&page=${page}&items_per_page=${limit}`,
        {}
      );

      const data = response.data;
      setJobTitleList(data.result.data);

    } catch (err) {
      console.log(err);
    }
    setIsLoading(false)
  };
  function clearData() {
    const clearedFilter = Object.fromEntries(
      Object.entries(filter).map(([key, value]) => [key, key === "rec_status" || key === "no_passport" ? value : ""])
    );

    setfilter(clearedFilter);
  }
  function clearSearch() {
    setTextInput("");
    changeFilters("keyword", "");
  }

  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Recruitments"
      isLoading={isLoading}
      actions={[
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              maxwidth: "75ch",
            },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-search"
            type="search"
            label="Search"
            variant="outlined"
            inputProps={{
              style: {
                width: "300px",
                fontSize: "14px",
              },
            }}
            size="small"
            placeholder="Enter search keyword"
            value={textInput}
            onChange={handleTextInputChange}
          />
        </Box>,
        <Button
          endIcon={<SearchOutlined />}
          className="mx-1"
          variant="contained"
          color="secondary"
          onClick={() => {
            changeFilters("keyword", "" + textInput);
          }}>
          Search
        </Button>,
        <Button
          variant={hide ? "outlined" : "contained"}
          color="secondary"
          onClick={hideDiv}
          startIcon={<FilterAltIcon fontSize="small" />}
        >
          {hide ? "More" : "Hide"} Filters
        </Button>
      ]}
      secondaryAction={<>
        {!hide ? (
          <Card className="flex w-full space-x-4 px-2 py-3 border " elevation={0}>
            <div className="flex">
              <TextField
                id="passport_no"
                variant="outlined"
                label="Passport Number"
                value={filter.passport_no || ""}
                onChange={(event) => {
                  changeFilters("passport_no", event.target.value)
                }}
                placeholder="Passport Number"
                size="small"
                name="passport_no"
              />
            </div>
            <div className="flex">
              <TextField
                id="mobile_no1"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                value={filter.mobile_no1 || ""}
                onChange={(event) => {
                  changeFilters("mobile_no1", event.target.value);
                }}
                label="Mobile Number"
                placeholder="07X XXX XXXX"
                size="small"
                name="mobile_no1"
              />
            </div>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              endIcon={<SearchOutlined />}
              onClick={() => {
                changeFilters("timestamp", "" + Date.now());
              }}
            >
              Search
            </Button>
            <Button className="mt-1" color="error" variant="text" onClick={clearData}>
              <CancelIcon />
            </Button>
          </Card>
        ) : (
          <div></div>
        )}
      </>}
      // mainAction={
      //   <Button
      //     variant="contained"
      //     color="primary"
      //     onClick={() => {
      //       setEditDialogVisibility(true);
      //       console.log(editDialogVisibility);
      //     }}
      //     startIcon={<AddIcon fontSize="small" />}
      //   >
      //     Create
      //   </Button>
      // }
    >
      <>
        <ResumeTable filter={filter} section="recruitments" triggerResumeId={triggerResumeId} onResumeTriggered={() => setTriggerResumeId(null)} />
      </>

    </Scaffold>
  )

};

export default Recruitments;
